// translations.js
export const translations = {
    "productSearch": "חיפוש מוצר",
    "partNumberSearch": 'חיפוש מק"ט',
    "promoProduct": 'מוצר קד"מ',
    "all": "הכל",
    "yes": "כן",
    "no": "לא",
    "product": "מוצר",
    "partNumber": 'מק"ט',
    "inventory": "מלאי",
    "unitname": 'יחידת מפעל',
    "conv": 'שיעור המרה',
    "SERIAL": 'אצווה',
    "quantity": "כמות",
    "noProducts": "אין מוצרים להצגה",
    "quantityExceedsInventory": "כמות חורגת ממלאי",
    "cancel": "ביטול",
    "confirm": "אישור"
  };